import { useFormContext } from 'react-hook-form';
import { useEffect, useRef } from 'react';
import { Stack } from '@optimus-web/core';
import { WithServiceId } from '@mews-commander/types';
import { FormCounterField } from '@mews/framework';
import { useResourceCategory } from '@mews-commander/legacy-entities/src/utils/useResourceCategory';
import { BlockSetUpVectorCell, BlockSetupMatrixVectorCellWrapper } from '../styles';
import { FIELD_ARRAY_AVAILABILITY, PAX_COUNT, PERSON_COUNT } from '../../../../../constants';
import { AvailabilityAdjustmentFormValues } from '../../../../../types';

const MIN = 1;

interface GuestCountCellProps extends WithServiceId {
    resourceCategoryId: string | undefined;
    rowIndex: number;
}

export const GuestCountCell = ({ resourceCategoryId, serviceId, rowIndex }: GuestCountCellProps) => {
    const { setValue } = useFormContext<AvailabilityAdjustmentFormValues>();
    const resourceCategory = useResourceCategory(resourceCategoryId ?? '', serviceId);
    const previous = useRef(resourceCategoryId);

    const maxCapacity = resourceCategory ? resourceCategory.capacity + resourceCategory.extraCapacity : MIN;

    const inputName = `${FIELD_ARRAY_AVAILABILITY}.${rowIndex}.${PAX_COUNT}.${PERSON_COUNT}` as const;

    useEffect(() => {
        // set a persons count for newly selected resource category id
        if (resourceCategory && previous.current !== resourceCategory.id) {
            setValue(inputName, resourceCategory.capacity ?? MIN);
        }
    }, [inputName, resourceCategory, setValue]);

    if (!resourceCategoryId) {
        return (
            <BlockSetUpVectorCell alignment="end">
                <></>
            </BlockSetUpVectorCell>
        );
    }

    return (
        <BlockSetupMatrixVectorCellWrapper data-test-resource-category={resourceCategoryId}>
            <Stack itemAlignment="center" fill>
                <FormCounterField name={inputName} min={MIN} max={maxCapacity} />
            </Stack>
        </BlockSetupMatrixVectorCellWrapper>
    );
};
